import React from "react";
import { Link } from "react-router-dom";
import ProjectsSection from "../../components/ProjectsSection";
import Testimonials from "../../components/Testimonials";

const CyberSecurity = () => {

  const projects = [
    { title: "Security Audit", desc: "Full vulnerability testing.", link: "#" },
    { title: "Cloud Protection", desc: "Secured cloud infrastructure.", link: "#" },
  ];

  const testimonials = [
    { name: "Security Lead", role: "CTO", feedback: "Highly reliable protection." },
    { name: "Ali Raza", role: "Business Owner", feedback: "Our systems are now fully secure." },
  ];

  return (
    <div className="text-white bg-black overflow-hidden">

      {/* HERO */}
      <section className="relative min-h-screen flex items-center justify-center text-center px-6">
        <div className="absolute w-[500px] h-[500px] bg-red-500/30 blur-[120px]"></div>

        <div className="relative z-10">
          <h1 className="text-6xl font-bold">
            Advanced <span className="text-red-400">Cyber Security</span>
          </h1>

          <div className="mt-8 flex gap-4 justify-center">
            <Link to="/contact" className="bg-red-500 px-6 py-3 rounded-full">Secure Now</Link>
            <a href="https://calendly.com/thelogicwaves/30min" className="border px-6 py-3 rounded-full">Book Call</a>
          </div>
        </div>
      </section>

      {/* WHAT WE DO */}
      <section className="py-24 grid md:grid-cols-3 gap-8 max-w-6xl mx-auto px-6">
        {["Pen Testing","Cloud Security","Threat Detection","Monitoring","Response","Audits"].map((item,i)=>(
          <div key={i} className="bg-white/5 p-6 rounded-xl border border-white/10">
            <h3 className="text-red-400">{item}</h3>
          </div>
        ))}
      </section>

      <ProjectsSection projects={projects} />
      <Testimonials testimonials={testimonials} />

      <section className="py-28 text-center bg-gradient-to-r from-red-500 to-pink-500">
        <h2 className="text-4xl font-bold">Secure Your Business 🔐</h2>
      </section>
    </div>
  );
};

export default CyberSecurity;